import { useLocalStorage } from '@src/customHooks/useLocalStorage';
import { LocalStorageKeys } from '@src/enums/localStorageKeys.enum';
import { QueryParams } from '../../interfaces/queryParams.interface';
import { RecentSearchItem } from './interfaces/recentSearchItem.interface';

export const useRecentSearches = (): {
  recentSearches?: RecentSearchItem[];
  removeRecentSearch: (id: string) => void;
  setRecentSearches: (queryParam: QueryParams) => void;
} => {
  const [recentSearchesInLocalStorage, setRecentSearchesInLocalStorage] = useLocalStorage<RecentSearchItem[]>(
    LocalStorageKeys.VT_RECENT_SEARCHES,
    [],
  );

  const setRecentSearches = (queryParams: QueryParams) => {
    const searchPatterns = queryParams?.searchPatterns;

    if (!searchPatterns?.length) {
      return;
    }

    setRecentSearchesInLocalStorage([
      { id: searchPatterns.map(({ pattern }) => pattern).join('-'), ...queryParams },
      ...(recentSearchesInLocalStorage?.slice(0, 4) || []),
    ]);
  };

  const removeRecentSearch = (id: string) => {
    setRecentSearchesInLocalStorage(recentSearchesInLocalStorage?.filter(recentSearch => recentSearch.id !== id) || []);
  };

  return {
    recentSearches: recentSearchesInLocalStorage,
    removeRecentSearch: removeRecentSearch,
    setRecentSearches: setRecentSearches,
  };
};
